import React from 'react'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Backdrop } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import CircularLoading from 'assets/icons/circular-loading.svg'

import * as directoryActions from 'actions/components/directory'

class BackdropLoading extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
    }
  }

  render () {
    const { classes, directory } = this.props
    const open = this.props.open || directory.display.backdropLoading
    // const handleClose = () => this.props.updateDisplayBackdropLoading(false)

    return (
      <Backdrop className={classes.backdrop} open={open}>
        <img className={classes.indicator} src={CircularLoading} alt='loading' />
      </Backdrop>
    )
  }
}

const styles = {
  backdrop: {
    zIndex: 1300,
  },
  '@keyframes rotate': {
    from: { transfrom: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  indicator: {
    animationName: '$rotate',
    animation: '800ms infinite linear',
    width: 80,
    height: 80,
  },
}

const mapStateToProps = (state) => {
  return {
    directory: state.directory,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(directoryActions, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(BackdropLoading)



// WEBPACK FOOTER //
// ./src/components/scenes/DirectoryPage/BackdropLoading.jsx